import { WidgetType } from './widget-type.enum';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export enum WidgetSourceType {
  ALARMS = 'ALARMS',
  DEVICE = 'DEVICE',
  SENSOR = 'SENSOR',
  SENSORTYPE = 'SENSORTYPE',
  KPI = 'KPI',
  FORMULA = 'FORMULA',
  FORMULATYPE = 'FORMULATYPE',
}

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class WidgetConfig {
  id?: string;
  title?: string;
  type: WidgetType;

  metadata?: Record<string, string>;

  // @ApiProperty({ type: Array })
  // superSetParams?: Array<SuperSetParam>;

  sourceId?: string;
  sourceType?: WidgetSourceType;
}
